import { FilterAttribute, SessionFilterViewProps } from './model'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { FilterTag, selectSessionFilterTags, setSessionFilterTags } from '../../store/sessionFilter/sessionFilter'
import styled from 'styled-components'
import { SelectOption } from '../SelectDropdown/SelectDropdown'
import { useSearchParams } from 'react-router-dom'

const SessionTagFilter = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 0.5rem;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.25rem;
  border: 1px dashed var(--zocks-gray-500);
  background: ${(props) => (props.selected ? 'var(--zocks-gray-200)' : '#fff')};
  border-color: ${(props) => (props.selected ? 'var(--zocks-gray-200)' : 'var(--zocks-gray-500)')};
  cursor: pointer;

  &:hover {
    border-style: solid;
  }
`

export const SessionTagsFilter: React.FC<SessionFilterViewProps> = ({ filterType, disabled = false, onFilterChanged }) => {
  const dispatch = useAppDispatch()
  const selectedTags = useAppSelector(selectSessionFilterTags)
  const selectOptionFilterTagMapping: { [key: string]: FilterTag } = {
    bot_sent: { attr: FilterAttribute.BOT_SENT, val: true },
    assistant_joined: { attr: FilterAttribute.ASSISTANT_JOINED, val: true },
    processed: { attr: FilterAttribute.PROCESSED, val: true },
    not_processed: { attr: FilterAttribute.PROCESSED, val: false },
    zocks_analyzed: { attr: FilterAttribute.ZOCKS_ANALYZED, val: true },
  }
  const selectableTags: SelectOption[] =
    filterType === 'past'
      ? [
          { id: 'processed', label: 'Processed' },
          { id: 'not_processed', label: 'Not processed' },
          { id: 'bot_sent', label: 'Zocks assistant not admitted' },
          { id: 'assistant_joined', label: 'No participants joined' },
          { id: 'zocks_analyzed', label: 'Zocks analyzed' },
        ]
      : []
  const [searchParams, setSearchParams] = useSearchParams()

  const handleTagClicked = (tag: SelectOption, selected: boolean) => {
    if (disabled) {
      return
    }
    if (selected) {
      dispatch(setSessionFilterTags([...selectedTags, selectOptionFilterTagMapping[tag.id]]))
      searchParams.set('tags', JSON.stringify([...selectedTags, selectOptionFilterTagMapping[tag.id]]))
    } else {
      const optionFilterTag = selectOptionFilterTagMapping[tag.id]
      dispatch(setSessionFilterTags(selectedTags.filter((t) => !(optionFilterTag && t.attr === optionFilterTag.attr && t.val === optionFilterTag.val))))
      const selectedCurrentTags = selectedTags.filter((t) => !(optionFilterTag && t.attr === optionFilterTag.attr && t.val === optionFilterTag.val))
      searchParams.set('tags', JSON.stringify(selectedCurrentTags))
      if (selectedCurrentTags.length < 1) {
        searchParams.delete('tags')
      }
    }
    searchParams.delete('filterId')
    onFilterChanged && onFilterChanged(searchParams)
  }

  return (
    <div>
      <div className='mb-1'>Filter by tags {selectedTags.length ? <>({selectedTags.length})</> : null}</div>
      <div className='d-flex gap-1 flex-wrap'>
        {selectableTags.map((tag) => {
          const isSelected = !!selectedTags.find((filterTag) => {
            const optionFilterTag = selectOptionFilterTagMapping[tag.id]
            return optionFilterTag && filterTag.attr === optionFilterTag.attr && filterTag.val === optionFilterTag.val
          })
          return (
            <SessionTagFilter selected={isSelected} onClick={() => handleTagClicked(tag, !isSelected)}>
              {isSelected ? <i className='bi bi-check2-circle' /> : <i className='bi bi-plus-circle' />} {tag.label}
            </SessionTagFilter>
          )
        })}
      </div>
    </div>
  )
}
